import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'web-ui-components/lib/global/layout';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import withContent from '../../containers/withContent';
import { deadlineMissedContent, contentPropTypes } from './DeadlineMissed.content';
import { hasApiCallInProgress } from '../../states/api/selectors';
import { longDateFormat, BACS_CREDIT_CODE, TYPE_IFT } from '../../config/';
import { getBacsTypePaymentToAuthorise, isChaps } from '../../states/payments/builders';

const mapState = (state) => ({
	hasApiCallInProgress: hasApiCallInProgress(state),
	bacsType: getBacsTypePaymentToAuthorise(state),
	isChaps: isChaps(state),
});

class DeadlineMissed extends Component {
	constructor(props) {
		super(props);
		this.getTitle = this.getTitle.bind(this);
		this.getBody = this.getBody.bind(this);
		this.getSettlementDateLabel = this.getSettlementDateLabel.bind(this);
	}
	getTitle() {
		const {
			isChaps,
			paymentType,
			content: { chapsTitle, deadlineMissedTitle, paymentDeadlineMissedTitle },
		} = this.props;
		if (paymentType === TYPE_IFT) return paymentDeadlineMissedTitle;
		return isChaps ? chapsTitle : deadlineMissedTitle;
	}
	getBody() {
		const {
			isChaps,
			paymentType,
			bacsType,
			content: { chapsBody, deadlineMissedBacsCreditBody, deadlineMissedBacsDebitBody, deadlineMissedPaymentBody },
		} = this.props;
		if (isChaps) return chapsBody;
		if (paymentType === TYPE_IFT) return deadlineMissedPaymentBody;
		return bacsType === BACS_CREDIT_CODE ? deadlineMissedBacsCreditBody : deadlineMissedBacsDebitBody;
	}
	getSettlementDateLabel() {
		const {
			isChaps,
			bacsType,
			paymentType,
			content: {
				chapsSettlementDateLabel,
				deadlineMissedBacsCreditSettlementDateLabel,
				deadlineMissedBacsDebitSettlementDateLabel,
				earlierSettlementDateLabel,
			},
		} = this.props;
		if (paymentType === TYPE_IFT) return earlierSettlementDateLabel;
		if (isChaps) return chapsSettlementDateLabel;
		return bacsType === BACS_CREDIT_CODE
			? deadlineMissedBacsCreditSettlementDateLabel
			: deadlineMissedBacsDebitSettlementDateLabel;
	}
	render() {
		const {
			submissionDate,
			settlementDate,
			handleCancelPayment,
			handleAcceptNewDates,
			hasApiCallInProgress,
			content: { deadlineMissedBacsSubmissionDateLabel, deadlineMissedAcceptButton, deadlineMissedCancelPaymentButton },
		} = this.props;
		return (
			<Modal isOpen shouldCloseOnOverlayClick={false}>
				<Container className="modal__container u-padding-y-4 u-text-align-center">
					<Icon iconType="ExclamationCircleLarge" size="lg" className="u-margin-x-auto u-margin-bottom-2" />
					<h2>{this.getTitle()}</h2>
					<div>
						<p>{this.getBody()}</p>
						<p>{`${deadlineMissedBacsSubmissionDateLabel} ${submissionDate.format(longDateFormat)}`}</p>
						<p>{`${this.getSettlementDateLabel()} ${settlementDate.format(longDateFormat)}`}</p>
						<div className="u-margin-bottom-2">
							<Button
								id="DeadlineMissedAcceptBtn"
								onClick={handleAcceptNewDates}
								width="flush"
								display="primary"
								isLoading={hasApiCallInProgress}
								disabled={hasApiCallInProgress}
							>
								{deadlineMissedAcceptButton}
							</Button>
						</div>
						<div>
							<Button
								id="DeadlineMissedCancelBtn"
								onClick={handleCancelPayment}
								width="flush"
								disabled={hasApiCallInProgress}
							>
								{deadlineMissedCancelPaymentButton}
							</Button>
						</div>
					</div>
				</Container>
			</Modal>
		);
	}
}

DeadlineMissed.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	submissionDate: PropTypes.shape({}).isRequired,
	settlementDate: PropTypes.shape({}).isRequired,
	hasApiCallInProgress: PropTypes.bool,
	handleCancelPayment: PropTypes.func.isRequired,
	handleAcceptNewDates: PropTypes.func.isRequired,
	bacsType: PropTypes.string.isRequired,
	paymentType: PropTypes.string.isRequired,
	isChaps: PropTypes.bool,
};

export const contentWrapper = withContent({ content: deadlineMissedContent })(DeadlineMissed);
export default connect(mapState)(contentWrapper);
